module.exports = __webpack_public_path__ + "media/svgs/text-infinity-330edfa8e13b4cf0b25cd31cb78b1bea.svg";